import { InjectionToken } from '@angular/core';

export interface CrossOriginXsrfConfig {
  trustedApiOrigins: readonly string[];
  cookieName: string;
  headerName: string;
}

export const CROSS_ORIGIN_XSRF_CONFIG = new InjectionToken<CrossOriginXsrfConfig>('CROSS_ORIGIN_XSRF_CONFIG');
